import { useMemo } from 'react';
import { FormField } from 'src/components';
import { useProjectLostReasons } from 'src/graphql/entities/project-lost-reason';

export interface ProposalLostFormValues {
  projectLostReason: { id: number; label: string; value: number };
  lostReasonNotes?: string;
}

export function useProposalLostForm() {
  const { projectLostReasons, loading: isLoadingProjectLostReasons } = useProjectLostReasons();

  const proposalLostFormFields = useMemo<FormField[]>(() => {
    return [
      {
        type: 'autocomplete' as const,
        name: 'projectLostReason' as const,
        'data-testid': 'proposal-lost-reason',
        label: 'Reason',
        options: projectLostReasons.map((reason) => ({
          id: reason.id,
          label: reason.name,
          value: reason.value,
        })),
        required: 'Estimated Day1 Date is required',
        defaultValue: null,
        loading: isLoadingProjectLostReasons,
      },
      {
        type: 'textfield' as const,
        name: 'lostReasonNotes',
        'data-testid': 'proposal-lost-notes',
        label: 'Additional Notes',
        defaultValue: '',
        textFieldProps: {
          InputProps: {
            multiline: true,
            minRows: 4,
          },
        },
      },
    ];
  }, [isLoadingProjectLostReasons, projectLostReasons]);

  return { proposalLostFormFields };
}
